export default __webpack_public_path__ + "static/media/flightTakeOffIcon.5b8ccfbc.svg";